export default {
    formId: 'editCustomerForm', //'editCustomerForm',
    formField: {
      e_name: {
        name: 'e_name',
        label: 'Nombre cliente*',
        requiredErrorMsg: 'El nombre cliente es requerido.'
      },
      e_address: {
        name: 'e_address',
        label: 'Direccion cliente*',
        requiredErrorMsg: 'La direccion es requerida.'
      },
      e_email: {
        name: 'e_email',
        label: 'Email*',
        requiredErrorMsg: 'El email es requerido.'
      },
      e_person_in_charge: {
        name: 'e_person_in_charge',
        label: 'Persona responsable*',
        requiredErrorMsg: 'La resposana responsable es requerida.'
      },
      e_contact: {
        name: 'e_contact',
        label: 'Contacto persona responsable*',
        requiredErrorMsg: 'La persona responsable es requerida.',
        typeDataMsg: 'El campo es numerico.'
      },
      e_second_person_in_charge: {
        name: 'e_second_person_in_charge',
        label: 'Segunda persona responsable',
        requiredErrorMsg: ''
      },
      e_second_customer_contact: {
        name: 'e_second_customer_contact',
        label: 'Contacto segunda persona responsable',
        requiredErrorMsg: '',
        typeDataMsg: 'El campo es numerico.'
      },
      e_phone: {
        name: 'e_phone',
        label: 'Telefono fijo cliente*',
        requiredErrorMsg: 'El telefono cliente es obligatorio.'
      },
      e_start_date: {
        name: 'e_start_date',
        label: 'Fecha inicio*',
        requiredErrorMsg: 'La fecha de inicio es obligatoria.'
      },
      e_status: {
        name: 'e_status',
        label: 'Cliente activo*',
        requiredErrorMsg: 'El estado es obligatorio.'
      },
      e_country: {
        name: 'e_country',
        label: 'Pais*',
        requiredErrorMsg: 'El pais es requerido.',
      },
      e_departament: {
        name: 'e_departament',
        label: 'Departamento*',
        requiredErrorMsg: 'El departamento es requerido.'
      },
      e_municipaly: {
        name: 'e_municipaly',
        label: 'Municipio*',
        requiredErrorMsg: 'El municipio es requerido.',
      },
      e_applications: {
        name: 'e_applications',
        label: 'Aplicaciones*',
        requiredErrorMsg: 'Debes selecionar por lo menos una aplicacion.',
      },
      e_subscription_ends_at: {
        name: 'e_subscription_ends_at',
        label: 'Fecha de pago',
        requiredErrorMsg: 'La fecha de pago es requerida.'
      },
    }
  };
  